import http from '../../../lib/http'
import { notify } from '../../../lib/Notification/actions.js'
import { getPatientBanner } from '../../PatientFolder/PatientBanner/actions.js'

// action types
export const PATIENT_CREATE = 'PATIENT_CREATE'
export const PATIENT_CREATE_SUCCESS = 'PATIENT_CREATE_SUCCESS'
export const PATIENT_CREATE_FAILURE = 'PATIENT_CREATE_FAILURE'

export const PATIENT_OPEN_MODAL = 'PATIENT_OPEN_MODAL'
export const PATIENT_RESET_FORM = 'PATIENT_RESET_FORM'
export const PATIENT_MODAL_CLIENTNAME_UPDATE =
  'PATIENT_MODAL_CLIENTNAME_UPDATE'

export const PATIENT_UPDATE = 'PATIENT_UPDATE'
export const PATIENT_UPDATE_SUCCESS = 'PATIENT_UPDATE_SUCCESS'
export const PATIENT_UPDATE_FAILURE = 'PATIENT_UPDATE_FAILURE'

// action creators
function createPatient () {
  return {
    type: PATIENT_CREATE
  }
}

function createPatientSuccess (savedPatient) {
  return {
    type: PATIENT_CREATE_SUCCESS,
    savedPatient
  }
}

export function resetPatientForm () {
  return {
    type: PATIENT_RESET_FORM
  }
}

export function openPatientModal () {
  return {
    type: PATIENT_OPEN_MODAL
  }
}

function createPatientFailure (error) {
  return {
    type: PATIENT_CREATE_FAILURE,
    error
  }
}

// action creators
function updatePatientStart () {
  return {
    type: PATIENT_UPDATE
  }
}

function updatePatientSuccess (savedPatient) {
  return {
    type: PATIENT_UPDATE_SUCCESS,
    savedPatient
  }
}

function updatePatientFailure (error) {
  return {
    type: PATIENT_UPDATE_FAILURE,
    error
  }
}

export function updatePatientModalClientName (clientName) {
  return {
    type: PATIENT_MODAL_CLIENTNAME_UPDATE,
    clientName
  }
}

/**
 * Action-creator function that saves the patient and dispatches the following actions
 * PATIENT_CREATE - dispatches that the patient is being created
 * PATIENT_CREATE_SUCCESS - dispatches that the patient was saved and contains action.savedPatient
 * PATIENT_CREATE_FAILURE - dispatches that the an error in the patient save
 * @param newPatient
 * @returns {Function}
 */
export function savePatient (newPatient, navigate) {
  let patientId
  let { _clientName: clientName, ...payload } = newPatient

  return dispatch => {
    dispatch(createPatient())
    return http
      .postRequest('/patients', payload, { clientName })
      .then(bundle => {
        let patient = bundle.entry.find(e => e.resource.resourceType === 'Patient').resource
        patientId = patient.id

        dispatch(createPatientSuccess(patient))
        return Promise.resolve(patient)
      })
      .then(() => dispatch(notify('Patient saved successfully.', false)))
      .then(() => {
        navigate(`/patient/${clientName}/${patientId}/patientFolder`)
      })
      .catch(err =>
        Promise.resolve(dispatch(createPatientFailure(err))).then(() =>
          dispatch(notify('Error saving patient.', true))))
  }
}

/**
 * Action-creator function that saves the patient and dispatches the following actions
 * PATIENT_UPDATE - dispatches that the patient is being created
 * PATIENT_UPDATE_SUCCESS - dispatches that the patient was saved and contains action.savedPatient
 * PATIENT_UPDATE_FAILURE - dispatches that the an error in the patient save
 * PATIENT_CLOSE_MODAL - dispatches that the modal needs to be closed
 * @param newPatient
 * @returns {Function}
 */
export function updatePatient (updatedPatient) {
  const clientName = updatedPatient._clientName

  delete updatedPatient._clientName
  return dispatch => {
    dispatch(updatePatientStart())
    return http
      .putRequest(`/patients/${updatedPatient.id}`, updatedPatient, {
        clientName
      })
      .then(savedPatient => dispatch(updatePatientSuccess(savedPatient)))
      .then(() => dispatch(notify('Patient updated successfully.', false)))
      .then(() => dispatch(getPatientBanner()))
      .catch(err =>
        Promise.resolve(dispatch(updatePatientFailure(err))).then(() =>
          dispatch(notify('Error updating patient.', true))))
  }
}
